import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

import Store from "./repo";

export default new Vuex.Store({
  state: {
    STATE_OTHER: Store.Others.STATE,
    STATE_PAGES: Store.Pages.STATE
  },
  actions: {
    setLoading: Store.Others.ACTION.LOADING,
    setArticle: Store.Pages.ACTION.ARTICLE,
    setArticles: Store.Pages.ACTION.ARTICLES
  },
  getters: {
    getLoading: Store.Others.GETTER.LOADING,
    getArticle: Store.Pages.GETTER.ARTICLE,
    getArticles: Store.Pages.GETTER.ARTICLES
  },
  mutations: {
    SET_LOADING: Store.Others.MUTATION.SET_LOADING,
    SET_ARTICLE: Store.Pages.MUTATION.SET_ARTICLE,
    SET_ARTICLES: Store.Pages.MUTATION.SET_ARTICLES
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js